import { createAsyncThunk } from '@reduxjs/toolkit';
import { CreateCreditLinkProps, CreateCreditEntryProps } from 'entities/Credit';
import * as service from 'services/credit.service';

export const getLinksByGenerator = createAsyncThunk(
  'credit/getLinksByGenerator',
  async (consumerUnitId: string, { rejectWithValue }) => {
    try {
      const r = await service.getLinksByGeneratorService(consumerUnitId);
      return r.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const getLinksByReceiver = createAsyncThunk(
  'credit/getLinksByReceiver',
  async (consumerUnitId: string, { rejectWithValue }) => {
    try {
      const r = await service.getLinksByReceiverService(consumerUnitId);
      return r.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const createCreditLink = createAsyncThunk(
  'credit/createLink',
  async (data: CreateCreditLinkProps, { rejectWithValue }) => {
    try {
      const r = await service.createCreditLinkService(data);
      return r.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const deleteCreditLink = createAsyncThunk(
  'credit/deleteLink',
  async (id: string, { rejectWithValue }) => {
    try {
      await service.deleteCreditLinkService(id);
      return id;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const getCreditEntries = createAsyncThunk(
  'credit/getEntries',
  async (consumerUnitId: string, { rejectWithValue }) => {
    try {
      const r = await service.getCreditEntriesService(consumerUnitId);
      return r.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const createCreditEntry = createAsyncThunk(
  'credit/createEntry',
  async (data: CreateCreditEntryProps, { rejectWithValue }) => {
    try {
      const r = await service.createCreditEntryService(data);
      return r.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const deleteCreditEntry = createAsyncThunk(
  'credit/deleteEntry',
  async (id: string, { rejectWithValue }) => {
    try {
      await service.deleteCreditEntryService(id);
      return id;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const validateCredits = createAsyncThunk(
  'credit/validate',
  async (consumerUnitId: string, { rejectWithValue }) => {
    try {
      const r = await service.validateCreditsService(consumerUnitId);
      return r.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);
